module.exports = __webpack_public_path__ + "static/media/SergioLopez_Resume.a78f933b.pdf";